import { ServiceModel } from '../../../../models/ServiceModel';
import { AuftragDefaultServiceModel } from '../../../../models/AuftragDefaultServiceModel';
import {
  convertDynamicToServiceModel,
  convertDynamicToServiceModelBEXITY,
} from '../../../../redux/actions/defaultAuftragServices';
import { BEXITY } from '../../admin/client-config-assembler';

const getServiceInitialDefaultList = () => {
  return [
    /*{
      id: 1,
      elementId: 1,
      bezeichnung: 'RID',
      wert: 'mit Gefahrgütern',
      backgroundColor: 'bg-amber800',
      hinweis: false,
      active: false,
      editable: false,
      defaultService: true,
      attributName: 'mitGefahrguetern',
    },*/
    {
      id: 1,
      elementId: 1,
      bezeichnung: 'Lenkeravis',
      wert: '',
      backgroundColor: 'bg-green900',
      hinweis: false,
      active: false,
      editable: false,
      defaultService: true,
      attributName: 'lenkeravis',
      isKostenpfl: true,
      spez_num: 49,
      typ: undefined,
      isAWSperre: false,
    },
    {
      id: 2,
      elementId: 2,
      bezeichnung: 'Abtragen',
      wert: '',
      backgroundColor: 'bg-lightBlueA200',
      hinweis: false,
      active: false,
      editable: false,
      defaultService: true,
      attributName: 'abtragen',
      isKostenpfl: true,
      spez_num: 48,
      typ: undefined,
      isAWSperre: false,
    },
    {
      id: 3,
      elementId: 3,
      bezeichnung: 'MyDelivery',
      wert: '',
      backgroundColor: 'bg-lime600',
      hinweis: false,
      active: false,
      editable: false,
      defaultService: true,
      attributName: 'myDelivery',
      isKostenpfl: false,
      spez_num: 151,
      typ: undefined,
      isAWSperre: false,
    },
    {
      id: 4,
      elementId: 4,
      bezeichnung: 'ADV3',
      wert: '',
      backgroundColor: 'bg-amber700',
      hinweis: false,
      active: false,
      editable: false,
      defaultService: true,
      attributName: 'adv3',
      isKostenpfl: false,
      spez_num: 152,
      typ: undefined,
      isAWSperre: false,
    },
  ];
};

const servicesInitialListeMMT: ServiceModel[] = [
  /* {
   /d: 1,
   elementId: 1,
   bezeichnung: 'geh weg',
   wert: '',
   backgroundColor: 'bg-lightBlueA200',
   hinweis: false,
   active: false,
   editable: false,
   defaultService: true,
   attributName: 'abtragen',
  },*/
];

let servicesFinalListe: ServiceModel[] = [];

export const getServiceInitialListe = (
  custom?: string,
  dynamicServices?: AuftragDefaultServiceModel[]
): ServiceModel[] => {
  servicesFinalListe = [];

  if (
    (dynamicServices && custom && custom != BEXITY) ||
    (dynamicServices && !custom)
  ) {
    servicesFinalListe = convertDynamicToServiceModel(dynamicServices);
  }
  /*if (custom && custom == 'MMT') {
    servicesFinalListe.push(...servicesInitialListeMMT);
  }*/
  //#84642 Hartcodierte Services nur noch bei BEXITY, alle anderen nur die, die Übertragen wurden
  if (custom && custom == BEXITY) {
    if (dynamicServices) {
      servicesFinalListe = convertDynamicToServiceModelBEXITY(dynamicServices);
    }
    //servicesFinalListe.push(...getServiceInitialDefaultList());   <----kan dann nach gründlicher prüfung gelöscht werden!!
  }
  servicesFinalListe = servicesFinalListe.sort(function (a, b) {
    if (a.id < b.id) return -1;
    return 1;
  });
  return servicesFinalListe.map(x => ({ ...x }));
};
